import { Button, ButtonText } from '@/ui/core/button'
import { Header } from '@/ui/core/header'
import { Screen } from '@/ui/core/screen'
import { HStack, VStack } from '@/ui/core/stack'
import { Image } from 'expo-image'
import { router } from 'expo-router'
import { useWindowDimensions } from 'react-native'
import Images from '#/assets/images/image-map'

const NotFoundScreen = () => {
	const { width } = useWindowDimensions()

	const returnHome = () => {
		router.push('/')
	}

	return (
		<HStack fullHeight>
			{width > 800 && (
				<Image
					style={{
						width: '45%',
						height: '100%',
						zIndex: 10,
					}}
					source={Images.ProfileHeadshotLarge}
					contentFit="cover"
				/>
			)}
			<Image
				style={{
					width: 16,
				}}
				source={Images.VerticalDivider}
				contentFit="cover"
			/>
			<Screen preset="fixed" className="flex flex-1">
				<VStack className="justify-center items-center h-full gap-8">
					<Header variant="h2">Page not found</Header>
					<Button onPress={returnHome} withArrow>
						<ButtonText>Go home</ButtonText>
					</Button>
				</VStack>
			</Screen>
		</HStack>
	)
}

export default NotFoundScreen
